/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/require-default-props */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * @deprecated This component is deprecated and will be removed in a future release.
 * Please use the new Quimby UI component instead:
 *
 * Import: `import { Toggle } from '@ui/molecules/inputs';`
 *
 * Or specific path: `import { Toggle } from '@ui/molecules/inputs/Toggle';`
 *
 * See the new component for documentation and migration notes.
 */
import React, { forwardRef } from 'react';
import './ToggleStyles.scss';
export const Toggle = forwardRef((_a, ref) => {
    var { checked, onChange, className = '', disabled = false, label, labelPosition = 'right', helperText } = _a, props = __rest(_a, ["checked", "onChange", "className", "disabled", "label", "labelPosition", "helperText"]);
    const toggleClass = `qmb-v2-toggle ${className}`;
    const hasLabel = Boolean(label);
    const wrapperClass = hasLabel ? 'qmb-v2-toggle-wrapper' : '';
    const positionClass = hasLabel ? `qmb-v2-toggle-wrapper--${labelPosition}` : '';
    const toggleElement = (React.createElement("label", { className: `${toggleClass} ${disabled ? 'qmb-v2-toggle--disabled' : ''}` },
        React.createElement("input", Object.assign({ ref: ref, type: "checkbox", className: "qmb-v2-toggle__input", checked: checked, onChange: onChange, disabled: disabled }, props)),
        React.createElement("span", { className: "qmb-v2-toggle__slider" })));
    if (!hasLabel) {
        return toggleElement;
    }
    return (React.createElement("div", { className: `${wrapperClass} ${positionClass}` },
        toggleElement,
        React.createElement("div", { className: "qmb-v2-toggle-wrapper__content" },
            React.createElement("span", { className: "qmb-v2-toggle-wrapper__label" }, label),
            helperText && React.createElement("span", { className: "qmb-v2-toggle-wrapper__helper-text" }, helperText))));
});
Toggle.displayName = 'Toggle';
